import { User } from '.';

export interface Judge {
  assignmentDate: string;
  user: User;
}

export function blankJudge(): Judge {
  return {
    assignmentDate: '',
    user: {
      userId: 0,
      emailAddress: '',
      firstName: '',
      lastName: '',
    }
  };
}
